// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__2IrWO","button_1":"style_button_1__2n6d3","button":"style_button__3_Ago"};